// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3wB71","link":"iR_eX","linkDetail":"c-p2C","icon":"_1yqub","text":"_3iPec","fileTypeAndSize":"_2yziG","cta":"_3ZJ7R"};